import React from "react";
import PropTypes from "prop-types";
import useWindowSize from "../hooks/useWindowSize";

const HighlightItem = props => {
  const { imageDesktop, imageMobile, altImage, title, text } = props;

  const { width } = useWindowSize();

  const isDesktop = width >= 1200;

  const imageUrl = isDesktop ? imageDesktop : imageMobile;

  return (
    <div className="highlight">
      <img src={imageUrl} className="highlight__image" alt={altImage} />
      <div className="highlight__title">{title}</div>
      <p className="highlight__text">{text}</p>
    </div>
  );
};

HighlightItem.propTypes = {
  altImage: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  imageDesktop: PropTypes.string,
  imageMobile: PropTypes.string
};

export default HighlightItem;
